import { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import config from '../config.js';
import { fetchListConceptes } from '../components/common/SelectConcepte.js';
import DataLoader from '../components/common/DataLoader.js';
import DetallConcepteMovimentComponent from '../components/common/DetallConcepteMoviment.js';

const DetallConcepteMoviment = () => {
  const [listConceptes, setListConceptes] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  const { userapp: paramUserapp, id: paramConcMovId } = useParams();
  const userapp = paramUserapp;
  const concMovId = paramConcMovId;

  const fetchFunction = (jwtToken, onData, onError, onFinally) => {
    axios.get(`${config.apiBaseUrl}/v1/concmovs/${concMovId}`, {
      headers: { Authorization: `${jwtToken}` }
    })
      .then((response) => {
        onData(response);
      })
      .catch((err) => {
        onError(err, 'cargar datos');
      })
      .finally(() => onFinally());

    fetchListConceptes(jwtToken,
      userapp,
      (data) => {
        setListConceptes(data);
      },
      (err) => {
        onError(err, 'cargar conceptes');
      }
    );
  };

  return (
    <DataLoader id={`${concMovId}_${reloadKey}`} fetchFunction={fetchFunction}>
      {(data, onError) => {
        return <DetallConcepteMovimentComponent
          data={data}
          userapp={userapp}
          concMovId={concMovId}
          listConceptes={listConceptes}
          onError={onError}
          onSave={() => setReloadKey(prev => prev + 1)} />;
      }}
    </DataLoader>
  );
};

export default DetallConcepteMoviment;
